<template>
  <v-data-table
    v-bind="this.$attrs"
    :options.sync="studentTableOptions"
    loading-text="Đang Tải"
    item-key="id"
    :headers="headers"
    :items="classesData"
    :server-items-length="totalItems"
    :search="search"
    :loading="loading"
    :footer-props="footerTable"
    no-data-text="Không có lớp"
    disable-sort
  >
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="white--text" v-if="item.status" :color="item.status | classStatusColor" label>
        {{ item.status | classStatus }}
      </v-chip>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" style="text-decoration: none; white-space: nowrap">
            <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/class/' + item.id">{{
              item.title
            }}</router-link>
          </div>
        </template>
        <span>Xem lớp</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ item.type | classType }}
    </template>
    <template v-slot:[`item.studentCount`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ item.students | getStudentCount }}
      </p>
    </template>
    <template v-slot:[`item.division`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ item.division | getDivision }}
      </p>
    </template>
    <template v-slot:[`item.academicLevel`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ item.academicLevel | getAcademicLevel }}
      </p>
    </template>
    <template v-slot:[`item.grade`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ item.grade | getGrade }}
      </p>
    </template>
    <template v-slot:[`item.teacher`]="{ item }">
      <div v-if="!item.teachers.length">--</div>
      <div v-else>
        <CardTeacherName v-for="teacher in item.teachers" :teacher="teacher" link :key="teacher.id" />
      </div>
    </template>
    <template v-slot:[`item.beginningDate`]="{ item }">
      <p style="margin: 0; white-space: nowrap">
        {{ get(item, 'beginningDate') ? moment(get(item, 'beginningDate')).format('DD/MM/YYYY') : '--' }}
      </p>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'

import moment from 'moment'
import get from 'lodash-es/get'

const originHeaders = [
  { text: 'Bộ môn', value: 'academicLevel' },
  { text: 'Tên lớp', value: 'title' },
  { text: 'Giáo viên giảng dạy', value: 'teacher' },
  { text: 'Sĩ số', value: 'studentCount', align: 'center' },
  { text: 'Trạng thái', value: 'status' },
  { text: 'Ngày khai giảng', value: 'beginningDate', align: 'end' },
  { text: 'Cơ sở', value: 'department.title', align: 'end' },
  { text: '', value: 'actions' },
]
export default {
  components: { CardTeacherName },
  props: {},
  data() {
    return {
      headers: originHeaders,
      draw: false,
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' },
        { text: 'Blocked', value: 'true' },
      ],
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      editClassId: '',
      dialog: false,
      sendState: false,
      studentTableOptions: {},
      moment,
      get,
    }
  },
  async created() {
    await this.refresh()
  },
  computed: {
    ...mapState('class', ['classData', 'classesData', 'totalItems', 'pageText', 'loading']),
    ...mapGetters('auth', ['role', 'profile']),
    ...mapGetters('class', ['classes']),

    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('class', [
      'fetchClasses',
      'setClass',
      'setClasses',
      'updateClasses',
      'removeClasses',
      'searchClasses',
      'requestPageSettings',
    ]),

    async refresh(query) {
      query = query || {}
      if (this.role.type === 'teacher') {
        query.headTeachers = [this.profile.id]
      }

      this.searchClasses({
        status: 'running',
        type: 'coreCurriculum',
        ...query,
      })
    },
  },
  filters: {
    getStudentCount(students) {
      return students.filter((s) => s.status === 'active').length
    },
    getRoom: (item) => {
      return get(item, 'title', '')
    },
    getTeacherNames: (classData) => {
      return classData.headTeachers.map((teacher) => teacher.name).join(', ')
    },
    getDivision: (division) => {
      return division ? division.title : ''
    },
    displayDate: (date) => {
      if (date) return moment(date).format('DD/MM')
    },
    getAcademicLevel: (acaLvl) => {
      return acaLvl ? acaLvl.title : ''
    },
    getGrade: (grade) => {
      if (!grade) return ''
      return `${grade.code} - ${grade.title}`
    },
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
